import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
  videoWrapper: ({ ratio }) => ({
    paddingBottom: `${100 / ratio}%`,
    position: 'relative',
    display: 'block',
    height: 0,
    padding: 0,
    overflow: 'hidden',
    backgroundColor: 'black',
    "& > div": {
      position: 'absolute',
      top: "50%",
      left: "50%",
      color: '#eee',
      transform: 'translate(-50%, -50%)',
    }
  }),
  video: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
}));

const Video = ({ src, ratio = 16 / 9, style = {}, onLoad }) => {
  const classes = useStyles({ ratio });
  // console.log({ ratio })
  return (
    <div className={classes.videoWrapper} style={style}>
      <div><CircularProgress color="primary" size="4rem" /></div>
      <iframe onLoad={onLoad} src={src} frameBorder="0" height="auto" className={classes.video} title="Educational video" allowFullScreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />
    </div>
  )
};

Video.propTypes = {
  src: PropTypes.string.isRequired,
}

export default Video;
